// import { Image, Table, Tag, Tooltip } from "antd";
// import { CiRead } from "react-icons/ci";
// import { useNavigate } from "react-router-dom";

// function DataTable({
//   data,
//   current,
//   pageSize,
//   total,
//   onPageChange,
//   filter,
// }: any) {
//   const navigate = useNavigate();

//   const columns = [
//     {
//       title: "Image",
//       render: (data: any) => (
//         <div className="rounded">
//           {data?.photo ? (
//             <Image src={data?.photo} alt="" height={80} width={80} />
//           ) : (
//             "No Image"
//           )}
//         </div>
//       ),
//     },
//     {
//       title: "Name",
//       render: (data: any) => `${data?.first_name} ${data?.last_name || ""}`,
//     },
//     {
//       title: "Admission No",
//       dataIndex: "admisson_id",
//     },
//     {
//       title: "Status",
//       render: () => (
//         <Tag color={filter === "Presents" ? "green" : "red"}>{filter}</Tag>
//       ),
//     },
//     {
//       title: "Action",
//       render: (item: any) => (
//         <div style={{ display: "flex", gap: 8 }}>
//           <Tooltip title="View">
//             <CiRead
//               size={20}
//               style={{ cursor: "pointer", color: "blue" }}
//               onClick={() => navigate(`/Auth/userDetails/${item?.id}`)}
//             />
//           </Tooltip>
//         </div>
//       ),
//     },
//   ];

//   return (
//     <div>
//       <Table
//         rowKey="id"
//         dataSource={data}
//         columns={columns}
//         size="small"
//         scroll={{ x: true }}
//       />
//     </div>
//   );
// }

// export default DataTable;
import { Image, Table, Tag, Tooltip } from "antd";
import { CiRead } from "react-icons/ci";
import { useNavigate } from "react-router-dom";

function DataTable({
  data,
  current = 1,
  pageSize = 10,
  total,
  onPageChange,
  filter,
}: any) {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Image",
      render: (data: any) => (
        <div className="rounded">
          {data?.photo ? (
            <Image src={data?.photo} alt="" height={80} width={80} />
          ) : (
            "No Image"
          )}
        </div>
      ),
    },
    {
      title: "Name",
      render: (data: any) => `${data?.first_name} ${data?.last_name || ""}`,
    },
    {
      title: "Admission No",
      dataIndex: "admisson_id",
    },
    {
      title: "Status",
      render: () => (
        <Tag color={filter === "Presents" ? "green" : "red"}>{filter}</Tag>
      ),
    },
    {
      title: "Action",
      render: (item: any) => (
        <div style={{ display: "flex", gap: 8 }}>
          <Tooltip title="View">
            <CiRead
              size={20}
              style={{ cursor: "pointer", color: "blue" }}
              onClick={() => navigate(`/Auth/userDetails/${item?.id}`)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  // Use data length if total is not provided
  const totalItems = total || (data?.length || 0);
  
  // Configure pagination
  const paginationConfig = {
    current: current,
    pageSize: pageSize,
    total: totalItems,
    onChange: onPageChange,
    showTotal: (total: number) => `Total ${filter}: ${total}`,
    showSizeChanger: true
  };

  return (
    <div>
      <Table
        rowKey="id"
        dataSource={data}
        columns={columns}
        size="small"
        scroll={{ x: true }}
        pagination={paginationConfig}
      />
    </div>
  );
}

export default DataTable;
